/**
 * The Tasks column on the Project Files page.
 *
 * Lives in its own module rather than on ProjectFilesPage because both the page (for sorting) and
 * ProjectFilesLineItem (for rendering) need it, and the render path runs
 * Page -> DropZone -> Table -> LineItem. Importing back from the page would close that into a cycle.
 */

/**
 * A file reaches this column one of two ways, and both render in the format the column has always
 * used, so a file with several links reads as a list rather than needing a new presentation:
 *
 *   - it was uploaded straight to a task, which OWNS it (node.task), or
 *   - it belongs to the project and one or more tasks LINK it (node.linkedTasks).
 *
 * A file can only be one or the other: a task-owned file has no project of its own, and linking
 * requires the file's project to match the task's.
 */
export function tasksColumnLabel(node) {
	const tasks = [];
	if (node && node.task) tasks.push(node.task);
	((node && node.linkedTasks) || []).forEach(task => tasks.push(task));
	return tasks.map(task => `T${task.companyTaskId} ${task.name}`).join(', ');
}

/**
 * Sort key for the column. It read a single companyTaskId before links existed; with several it
 * orders by the first listed, which is what the user sees at the start of the cell.
 */
export function firstLinkedTaskId(node) {
	if (node && node.task) return node.task.companyTaskId;
	const linked = (node && node.linkedTasks) || [];
	return linked.length ? linked[0].companyTaskId : null;
}
